<template>
  <div>
  <b-modal :no-close-on-backdrop="true" id="category-filter-modal" :ok-title="$t('common.ok')" ok-only centered size="lg" :title="`${$t('common.select')} ${$t(
                'warehouse.one-category'
              )}`">
    <b-card-text>
      <b-row>
        <b-col md="12">
          <AutoComplete v-model="selectedCategory" :label="$t('warehouse.category')" placeholder="Select Category"
            :serializer="(val) => val" endpoint="category" text-title="name" :otherQuery="`filter[type]=${isPharmacy?'pharmacy':'hospital'}`" @input="onCategorySelected" />
        </b-col>
        <b-col md="12" v-if="shouldRenderSubcategory">
          <recursive-category-auto-complete :category="selectedCategory" :depth="1" @final-value="handleFinalValue" />
        </b-col md="12">
      </b-row>
    </b-card-text>
  </b-modal>
    <b-form-group :label="$t('warehouse.category')" label-for="Name">
              <b-form-input
                id="Name"
                v-model="selectedCategory.name"
                :placeholder="$t('warehouse.one-category')"
                @click="$bvModal.show('category-filter-modal')"
              />
            </b-form-group>
  </div>
</template>
<script>
import { BCard, BRow, BCol, BButton, BCardText,    BFormGroup,BFormInput,
 } from 'bootstrap-vue';

const AutoComplete = () => import('@/components/common/AutoComplete.vue');
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
const RecursiveCategoryAutoComplete = () =>
  import('@/components/common/RecursiveCategoryAutoComplete.vue');


export default {
  components: {
    BRow,
    BFormGroup,BFormInput,
    BCol,
    BCard,
    BCardText,
    BButton,
    AutoComplete,
    ToastificationContent,
    RecursiveCategoryAutoComplete
  },

  computed: {
    shouldRenderSubcategory() {
      return (
        this.selectedCategory &&
        this.selectedCategory.childs &&
        this.selectedCategory.childs.length > 0
      );
    },
  },
    props:['isPharmacy'],

  data() {
    return {
      selectedCategory: {
        name:null,
        id:''
      },
    };
  },

  methods: {
    onCategorySelected(value) {
    
        this.$emit('category', this.selectedCategory);

     
     

    },
    handleFinalValue(value) {
      this.selectedCategory=value
      this.$emit('category', value);

    },
  },
};
</script>
